import { jsx as _jsx } from "react/jsx-runtime";
function SvgComponent() {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "transparent", viewBox: "0 0 24 24", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "prefix__feather prefix__feather-check", children: _jsx("path", { d: "M20 6L9 17l-5-5" }) }));
}
export default SvgComponent;
